import React, { FC } from "react";
import { RuleExpenseComponent } from "../../components";
import {
  PageEnum,
  RuleExpRecipeAccountsEnum,
} from "../../models";

export const RuleExpenseMoneyPage: FC<{}> = () => {
  return (
    <>
      <RuleExpenseComponent
        formId={PageEnum.RuleExport}
        acTransactionType={RuleExpRecipeAccountsEnum.Expense}
      />
    </>
  );
};
export const RuleReceiveMoneyPage: FC<{}> = () => {
  return (
    <>
      <RuleExpenseComponent
        formId={PageEnum.RuleReceive}
        acTransactionType={RuleExpRecipeAccountsEnum.Receive}
      />
    </>
  );
};
